import { SET_MOBILE_MENU_VISIBILITY } from './types';

const defaultState = {
    menuVisible: false
};

/**
 * Infrastructure state mapper.
 * @param {object} state
 * @param {string} action
 */
export default function(state = defaultState, action) {
    switch (action.type) {
        case SET_MOBILE_MENU_VISIBILITY:
            return { ...state, menuVisible: action.data };

        default:
            return state;
    }
}

export function setMobileMenuVisibility(visible) {
    return async function(dispatch) {
        dispatch({ type: SET_MOBILE_MENU_VISIBILITY, data: visible });
    };
}



// WEBPACK FOOTER //
// ./src/reducers/infrastructure.jsx